import { defineStore } from "pinia";
import {PersonInfoConstant} from "@/common/constant/PersonInfoConstant";

export const PersonInfoStore = defineStore("PersonInfoStore", {
    state: () => ({
       applicantType: PersonInfoConstant.CUSTOMER
    })
});